module.exports = __webpack_public_path__ + "img/estacionamento.9015546d.svg";